module.exports = __webpack_public_path__ + "img/instrument-milwaukee.1ce6e1b7.svg";